import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;

  .title {
    text-align: center;
    margin-bottom: 16px; 
  }

  .sub-title {
    text-align: center;
    margin-bottom: 16px;
    height: 20px;
    color: ${(props) => props.theme.colors.red};
  }

  .actions {
    display: flex;
    justify-content: space-between;

  }
`;

export default { Wrapper };
